import React from "react";
import DatePicker from "react-datepicker";
import { subMonths, addYears } from "date-fns";
import DateHelper from "../DateHelper/DateHelper";

// Date Picker Docs https://reactdatepicker.com/#example-calendar-start-day https://github.com/Hacker0x01/react-datepicker/tree/master/docs

export default class DatePickerInput extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className="date-picker-input">
        <div className="input-group date-picker-input-wrapper">
          <DatePicker
            className={
              this.props.classNames || this.props.className
                ? `${this.props.classNames || this.props.className} form-control`
                : "form-control"
            }
            name={this.props.name}
            dateFormat={DateHelper.rubyToDateFNS(this.props.dateFormat)}
            dayClassName={(date) => "DatePickerInput-calendar-days"}
            selected={this.props.selectedDate || null}
            showPopperArrow={false}
            todayButton={I18n.t("today")}
            minDate={
              this.props.minDate
                ? this.props.minDate
                : subMonths(new Date(), 12)
            }
            maxDate={
              this.props.maxDate ? this.props.maxDate : addYears(new Date(), 12)
            }
            showMonthDropdown
            showYearDropdown
            onChange={
              this.props.customChangeHandler
                ? this.handleCustomChange
                : this.props.onChange
            }
            popperPlacement={this.props.popperPlacement}
            // withPortal={window.top.innerHeight < 600}
            placeholderText={this.props.placeholderText || this.props.placeholder || ''}
          />
        </div>
      </div>
    );
  }

  handleCustomChange = (date) => {
    if (this.props.customChangeSource === "EmailCampaigns") {
      this.props.customChangeHandler(date, this.props.field);
    } else if (this.props.customChangeSource === "FormField") {
      this.props.customChangeHandler(date, this.props.formFieldID);
    } else if (this.props.customChangesource === "DatatableSearch") {
      this.props.customChangeHandler(date, this.props.name);
    } else if (this.props.customChangeSource === "syntheticTarget") {
      const syntheticObject = {
        target: { name: this.props.name, value: date },
      };
      this.props.customChangeHandler(syntheticObject);
    }
  };
}
